import styled from '@emotion/styled';
import { casinoColors } from 'src/assets/colors';
import { PlusIcon } from 'src/assets/icons/PlusIcon';
import { ScrollBarVertical } from 'src/domains/layouts/shared/scrollbar/Scrollbar.style';

export const cmsCategoriesPageHeight = 'calc(100vh - 210px)';

export const CategoriesPageWrapper = styled(ScrollBarVertical, { label: 'CategoriesPageWrapper' })`
    background: ${casinoColors.bgColorPage};
    border-radius: 4px;
    display: flex;
    flex-flow: column nowrap;
    margin-top: 24px;
    max-height: ${cmsCategoriesPageHeight};
    padding: 8px;
`;

export const PlusIconWrapper = styled(PlusIcon, { label: 'PlusIconWrapper' })`
    margin-right: 8px;
`;
